// hooks/useVisits.js
import { useState, useEffect, useCallback } from 'react';
import { visitService } from '../services/visitService';
import { fmtDateTime  } from '../../../../cabinet/visits/activity';

const TARGETS = {
  invite: 'Оформлення дитини до садочка',
  free: 'Консультація'
};

export const useVisits = (kgId) => {
  const [visits, setVisits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedVisitIndex, setSelectedVisitIndex] = useState(-1);

  const loadVisits = useCallback(async () => {
    setLoading(true);
    setError(null);
    
    try {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      const futureDate = new Date(today);
      futureDate.setDate(futureDate.getDate() + 10);

      const response = await visitService.getVisitsList(kgId, today, futureDate);

      if (response?.data?.[0]?.visits) {
        const newVisits = response.data[0].visits.map((row, index) => ({
          idx: index + 1,
          date: `${fmtDateTime(row.date)}`,
          date_orig: row.date,
          topic: TARGETS[row.type_vis?.target] || row.type_vis?.target || '-',
          name: row.contacts?.name || '-',
          phone: row.contacts?.phone || '-',
          status: ''
        }));
        setVisits(newVisits);
      } else {
        setVisits([]);
      }
    } catch (err) {
      setError(err.message || 'Помилка завантаження записів');
      console.error('Error loading visits:', err);
    } finally {
      setLoading(false);
    }
  }, [kgId]);

  useEffect(() => {
    loadVisits();
  }, [loadVisits]);

  const updateVisitStatus = async (value, text) => {
    if (selectedVisitIndex < 0 || selectedVisitIndex >= visits.length) return false;

    const visit = visits[selectedVisitIndex];
    
    try {
      await visitService.updateVisit(kgId, visit.date_orig, value, text);
      await loadVisits();
      setSelectedVisitIndex(-1);
      return true;
    } catch (err) {
      setError(err.message || 'Помилка оновлення запису');
      console.error('Error updating visit:', err);
      return false;
    }
  };

  return {
    visits,
    loading,
    error,
    selectedVisitIndex,
    setSelectedVisitIndex,
    updateVisitStatus,
    refresh: loadVisits
  };
};